<template lang="pug">
div
  y-dialog(v-model="showDialog" fullscreen max-width="600" persistent scrollable content-class="round-3xl")
    v-card.neutral200
      v-card-title.px-8.pt-8
        v-row(no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="closeDialog" height)
              v-icon(color="basic800" :size="24") mdi-arrow-left
          v-col.ml-3
            .text-2xl.font-semibold.neutral700--text Select preferred times

      v-card-text.pa-8
        v-container.pa-0(style="max-width: 800px;")
          //- Loading state
          template(v-if="isFetching")
            v-skeleton-loader.mb-6(type="text@4")
            v-skeleton-loader(type="text@4")
          //- Error state
          template(v-else-if="isError")
            v-card.pa-4.danger-border(outlined)
              .text-sm.danger500--text Opss.. An error occured
          //- Listing
          v-form(v-else ref="form")
            v-card.pa-8.round-xl.white.mb-6(v-if="sessions.length > 0" outlined style="border-color: var(--v-neutral300) !important; border-width: 1.5px !important;")
              div.text-xl.font-semibold.neutral700--text.mb-6 Edit selected appointment times
              div.d-flex.align-center.mb-4
                div.text-sm.font-semibold.neutral700--text Appointment {{ index + 1 }}
                v-spacer
                v-menu(offset-x left top rounded="lg")
                  template(#activator="{ on }")
                    v-btn.ml-4(icon small v-on="on")
                      v-icon mdi-dots-horizontal
                  v-list.py-0
                    template(v-for="(action, actidx) in actionList")
                      v-divider(v-if="actidx !== 0")
                      v-list-item(@click="action.action()" :key="'action-' + actidx")
                        v-list-item-title.text-sm(:class="[action.textColor]") {{ action.text }}

              div(v-for="session in sessions" :key="session.id")
                edit-combo-session-item(:session.sync="session")

      v-divider
      v-card-actions.py-4(:class="$vuetify.breakpoint.xsOnly ? 'px-4' : 'px-8'")
        v-spacer
        v-btn.button-md.underline.px-0(text @click="closeDialog") {{ $t('close') }}

  .dialogs
    y-dialog(v-model='showPicker' width='400px' persistent content-class="round-3xl")
      v-card
        v-card-text.px-2.pt-2.pb-0
          div.d-flex.justify-center.align-center(v-if="isFetchingDates" style="height: 380px;")
            v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
          yc-date-picker(v-else :parentDate.sync="selectedDate" :allowedDates="unavailableDateList" :minDate="getMinDate()" :parentPickerDate.sync="pickerDate")
        v-card-actions.px-4.pb-4
          v-row(no-gutters)
            v-col.pr-2
              v-btn.button-sm(color="neutral700" block dark outlined depressed @click="showPicker = false") {{ $t('cancel') }}
            v-col.pl-2
              v-btn.button-sm(color="neutral700" block depressed :dark="Boolean(selectedDate)" :disabled="!selectedDate" @click="pickDate(selectedDate)") {{ $t('select') }}

    cancel-appointment(v-if="openCancelAppointmentDialog" :open.sync="openCancelAppointmentDialog" :selectedAppointment="selectedAppointment" @reset="closeDialogSkip")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EditComboSessionItem from '@/components/clinic/appointment/advance/EditComboSessionItem.vue'
import RescheduleDate from '@/components/clinic/dialogs/RescheduleDate.vue'
import CancelAppointment from '@/components/clinic/dialogs/CancelAppointment.vue'

export default {
  components: {
    EditComboSessionItem,
    RescheduleDate,
    CancelAppointment,
  },
  props: {
    open: {
      type: Boolean
    },
    selectedAppointment: {
      type: Object,
      default: null
    },
    comboFor: {
      type: Number,
      default: null
    },
    index: {
      type: Number,
      default: 0
    },
    hideCancelled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isFetching: true,
      isFetchingDates: false,
      isError: false,
      showPicker: false,
      openRescheduleDateDialog: false,
      openCancelAppointmentDialog: false,
      selectedDate: null,
      pickerDate: null,
      pageSize: -1,
      oriSessions: [],
      sessions: [],
      sessionrows: [],
      actions: [
        { id: 'reschedule', text: this.$t('reschedule_new_date'), action: () => (this.showPicker = true), textColor: 'neutral700--text' },
        { id: 'cancel', text: this.$t('cancel_this_appointment'), action: () => (this.openCancelAppointment()), textColor: 'danger500--text' },
      ],
    }
  },
  mounted () {
    this.fetchAppointment()
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      hqSelectedCompany: 'hq/getSelectedCompany',
      isHq: 'hq/getIsHq'
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    hasChanges () {
      if (JSON.stringify(this.oriSessions) !== JSON.stringify(this.sessions)) {
        return true
      }
      return false
    },
    actionList () {
      const reschedule = ['reschedule']
      if (this.hideCancelled) { return reschedule.map(m => { return { ...this.actions.find(f => f.id === m) } })  }
      return this.actions
    },
  },
  watch: {
    pickerDate (val) {
      if (!val) { return }
      this.fetchComboUnavailableDates(this.sessionrows, val)
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchAppointment () {
      this.isFetching = true
      let params = {
        page_size: this.pageSize,
        combo_for: this.comboFor,
        ordering: 'id'
      }
      const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
      this.$axios.get(`/clinics/${companySlug}/appointments`, { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.sessions = resp.data.results.map((result, index) => ({...result, index}))
            this.oriSessions = JSON.parse(JSON.stringify(this.sessions))
            this.sessionrows = resp.data.results.map(m => {
              return  {
                service: m.services[0].id,
                provider: m.provider.id
              }
            })
          }
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.isError = true
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    async fetchComboUnavailableDates (rows, yearMonth) {
      this.isFetchingDates = true
      let unavail = []
      for (let i = 0; i < rows.length; i++) {
        let error = false
        let service = rows[i].service
        let provider = rows[i].provider
        let params = { service, provider }
        if (yearMonth) {
          params.year = yearMonth.substr(0, 4),
          params.month = yearMonth.substr(-2)
        }
        await this.$axios.get(`/clinics/${this.company.slug}/block_dates`, { params })
          .then(resp => {
            if (resp.data && resp.data.length) {
              for (let j = 0; j < resp.data.length; j++) {
                if (!unavail.includes(resp.data[j])) {
                  unavail.push(resp.data[j])
                }
              }
            } 
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data?.detail) {
              message = err.response.data.detail
            }
            this.showMessage(['error', message])
            error = true
          })
        if (error) {
          break
        }
      }
      this.unavailableDates = unavail
      this.isFetchingDates = false
    },
    openRescheduleDate () {
      this.openRescheduleDateDialog = true
    },
    openCancelAppointment () {
      this.openCancelAppointmentDialog = true
    },
    pickDate (date) {
      console.log(date)
      this.isFetching = true
      this.sessions = this.sessions.map(m => { return { ...m, start: null, preset_date: date } })
      this.showPicker = false
      setTimeout(() => {
        this.isFetching = false
      }, 1000)
    },
    closeDialog () {
      if (!this.$refs.form.validate() && this.hasChanges) {
        return
      }
      this.showDialog = false
      this.$emit('closed')
    },
    closeDialogSkip () {
      this.showDialog = false
      this.$emit('closed')
    },
    unavailableDateList (val) {
      if (this.unavailableDates.includes(val)) {
        return false
      }
      return true
    },
    getMinDate () {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`;
    },
  }
}
</script>

<style lang="scss" scoped>

</style>